import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPianoKeyboard = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "Layer_1",
	"data-name": "Layer 1",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m19,2H5C2.243,2,0,4.243,0,7v10c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V7c0-2.757-2.243-5-5-5Zm-14,2h14c1.654,0,3,1.346,3,3v4H2v-4c0-1.654,1.346-3,3-3Zm14,16H5c-1.654,0-3-1.346-3-3v-4h3v3c0,.552.448,1,1,1s1-.448,1-1v-3h2v3c0,.552.448,1,1,1s1-.448,1-1v-3h2v3c0,.552.448,1,1,1s1-.448,1-1v-3h2v3c0,.552.448,1,1,1s1-.448,1-1v-3h3v4c0,1.654-1.346,3-3,3Z" })
});
export default SvgPianoKeyboard;
